import axios from "axios";
import MemoryType from "../memory/enum/MemoryType";
import { notification } from "antd";
import LocalStorageHandler from "../memory/handler/LocalStorageHandler";

const devBaseURL = "https://nd05.truliacare.com/pdvapi/";
const prodBaseURL = "https://patient-data-vault.net/pdvapi/";

const apiClient = axios.create({
  baseURL: prodBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const localStorage = new LocalStorageHandler();
    const token = localStorage.read(MemoryType.TOKEN);
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const apiService = {
  get: async (endpoint, params = {}) => {
    try {
      const response = await apiClient.get(endpoint, { params });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  post: async (endpoint, data = {}, successMessage, errorMessage) => {
    try {
      const response = await apiClient.post(endpoint, data);
      handleSuccess(successMessage);
      return response.data;
    } catch (error) {
      handleError(errorMessage);
    }
  },

  put: async (endpoint, data = {}, successMessage, errorMessage) => {
    try {
      const response = await apiClient.put(endpoint, data);
      handleSuccess(successMessage);
      return response.data;
    } catch (error) {
      handleError(errorMessage);
    }
  },

  delete: async (endpoint, params = {}, successMessage, errorMessage) => {
    try {
      const response = await apiClient.delete(endpoint, { params });
      handleSuccess(successMessage);
      return response.data;
    } catch (error) {
      handleError(errorMessage);
    }
  },
};

const handleError = (errorMessage) => {
  if (errorMessage) {
    notification.error({
      message: errorMessage,
      placement: "bottomRight",
    });
  }
};

const handleSuccess = (successMessage) => {
  if (successMessage) {
    notification.success({
      message: successMessage,
      placement: "bottomRight",
    });
  }
};

export default apiService;
